export default async function GetAllTimesheetsApi(performanceCycleId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/timesheets/all?performanceCycleId=${performanceCycleId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error fetching all timesheets: ", error);
        res = { success: false, message: error.message };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: error.message };
  }

  return res;
}
